var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tdesign:certificate-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2 6H46V42H2V6ZM10 22V26H22V22H10ZM10 30V34H38V30H10ZM33.004 17.376L38 21.5V10H28.008V21.5L33.004 17.376Z",
    fill: "url(#paint0_linear_422_4511)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_422_4511",
    x1: 46,
    y1: 6,
    x2: 2,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    stopColor: "#9DE8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F57D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8CED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.04c69ea2c064b8065ffc49db3334606b.svg";
export { ForwardRef as ReactComponent };